import { render, staticRenderFns } from "./AddressDataForm.vue?vue&type=template&id=34abf3de&"
import script from "./AddressDataForm.vue?vue&type=script&lang=js&"
export * from "./AddressDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports